import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initMetricool, trackMetricoolPage } from "../lib/metricool";

export default function MetricoolTracker() {
   const location = useLocation();

   useEffect(() => {
      initMetricool();
   }, []);

   useEffect(() => {
      trackMetricoolPage();
   }, [location.pathname]);

   return null;
}
